module.exports = __webpack_public_path__ + "img/flower-left.01294746.png";